import React, { useState } from 'react';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services/index.js';
import { trigger } from '@philips-internal/oswald-ui-utils';
import { ReactComponent as Cross } from '../../../../resources/assets/components/DLS_Cross.svg';
import { ColorForm } from './color-form/color-form.js';
import { getColorGlobalValues, getColorNeutralValues, getColorSafetyValues, getColorSignalValues } from './color-palette/color-palette-utils.js';
import { ColorPalette } from './color-palette/color-palette.js';
import './color-picker.css';
function ColorPicker(props) {
    const [overColor, setOverColor] = useState({});
    const onMouseOver = (color, shade = '') => {
        setOverColor({
            color,
            shade,
        });
    };
    return (React.createElement("div", { className: "c-color-picker" },
        React.createElement("div", { className: "c-color-picker__colorset" },
            React.createElement("div", { className: "c-color-picker__color-type" },
                React.createElement("label", { className: "c-color-picker__title" }, MessageService.translate('tws.color-picker.neutral-colors')),
                React.createElement(ColorPalette, { ...props, onMouseOver: onMouseOver, values: getColorNeutralValues() })),
            React.createElement("div", { className: "c-color-picker__color-type" },
                React.createElement("label", { className: "c-color-picker__title" }, MessageService.translate('tws.color-picker.global-colors')),
                React.createElement(ColorPalette, { ...props, onMouseOver: onMouseOver, values: getColorGlobalValues() })),
            React.createElement("div", { className: "c-color-picker__color-type" },
                React.createElement("label", { className: "c-color-picker__title" }, MessageService.translate('tws.color-picker.signal-colors')),
                React.createElement(ColorPalette, { ...props, onMouseOver: onMouseOver, values: getColorSignalValues() })),
            React.createElement("div", { className: "c-color-picker__fieldset" },
                React.createElement("div", { className: "c-color-picker__color-type" },
                    React.createElement("label", { className: "c-color-picker__title" }, MessageService.translate('tws.color-picker.safety-colors')),
                    React.createElement(ColorPalette, { ...props, onMouseOver: onMouseOver, values: getColorSafetyValues() })),
                !props.showForm && props.selected
                    ? React.createElement(Cross, { className: "c-color-picker__reset", onClick: trigger(props.onClick) })
                    : null)),
        props.showForm
            ? React.createElement(ColorForm, { colorName: overColor.color, onClick: props.onClick, selected: props.selected, shade: overColor.shade })
            : null));
}
export { ColorPicker, };
//# sourceMappingURL=color-picker.js.map